import fixturesConfig from './fixtures.config';

const defaults = {
  ENV: 'prod',
  MOCKAPI: false,
  // URL: "http://127.0.0.1:8000/api",
  // URL: 'http://127.0.0.1:8000/api.dev.kliksekolah/api',
  // URL: 'https://dev.api.kliksekolah.com/api', // ganti ini sementara
  //URL: 'https://api.demo.kliksekolah.com/api', // awalnya pake ini
  //URL: 'https://dev.api.kliksekolah.com/api',
  URL: 'https://api.kliksekolah.com/api',
  // URL: 'https://dev.api.olifant.kliksekolah.com/api',


  URL_2: 'https://staff.kliksekolah.com/api',
  URL_3: 'https://tax.kliksekolah.com/api',
  API_AKADEMIS: 'https://academics.api.kliksekolah.com',
  //API_AKADEMIS: 'https://dev.api.academics.kliksekolah.com',
  API_LOCAL: 'https://academics.api.kliksekolah.com', //coba server
  //API_LOCAL: 'http://localhost:8080/', //api local
  //API_LOCAL: 'https://dev.api.academics.kliksekolah.com', // coba api dev
  API_BRIDGE: 'https://apiauth.kliksekolah.com',
  fixtures: fixturesConfig,
  subdomain_payment : window.location.hostname.split('.').slice(0, -2).join('.'),
};

const setEnv = (envKey, value) => {
  defaults[envKey] = value;
  return defaults;
};

export default {
  setEnv,
  ENV: defaults.ENV,
  MOCKAPI: defaults.MOCKAPI,
  URL: defaults.URL,
  URL_2: defaults.URL_2,
  URL_3: defaults.URL_3,
  API_BRIDGE: defaults.API_BRIDGE,
  API_AKADEMIS: defaults.API_AKADEMIS,
  API_LOCAL: defaults.API_LOCAL,
  fixtures: defaults.fixtures,
  PASSWORD: defaults.password,
  subdomain_payment: defaults.subdomain_payment,
};